import { KindeProvider, useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useEffect, useState } from "react";
import Dashboard from "./components/Dashboard";
import HomePage from "./components/HomePage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import CookieBanner from "./components/CookieBanner";
import ErrorBoundary from "./components/ErrorBoundary";

function AppContent() {
  const { login, register, isAuthenticated, isLoading } = useKindeAuth();
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'Arial, sans-serif',
        color: '#6b7280'
      }}>
        Loading...
      </div>
    );
  }

  // Handle legal pages (accessible to everyone)
  if (currentPath === '/privacy') {
    return (
      <>
        <PrivacyPolicy />
        <CookieBanner />
      </>
    );
  }

  if (currentPath === '/terms') {
    return (
      <>
        <TermsOfService />
        <CookieBanner />
      </>
    );
  }

  if (!isAuthenticated) {
    return (
      <>
        <HomePage onLogin={login} onRegister={register} />
        <CookieBanner />
      </>
    );
  }

  return (
    <>
      <Dashboard />
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <KindeProvider
        clientId={process.env.REACT_APP_KINDE_CLIENT_ID}
        domain={process.env.REACT_APP_KINDE_DOMAIN}
        redirectUri={process.env.REACT_APP_KINDE_REDIRECT_URI}
        logoutUri={process.env.REACT_APP_KINDE_LOGOUT_REDIRECT_URI}
        scope="openid profile email"
      >
        <AppContent />
      </KindeProvider>
    </ErrorBoundary>
  );
}

export default App;
